export default(() => {
    const notificationAddresses = {
        general: 'info@cleanenergycouncil.org.au',
        accreditationInstaller: 'accreditation@cleanenergycouncil.org.au',
        membership: 'membership@cleanenergycouncil.org.au',
        media: 'media@cleanenergycouncil.org.au',
        eventsSponsorship: 'events@cleanenergycouncil.org.au',
        approvedSolarRetailers: 'codeofconduct@cleanenergycouncil.org.au',
        consumerEnquiry: 'consumerenquiries@cleanenergycouncil.org.au',
    };
    const form = document.querySelector('#enquiryForm');

    if (form) {
        const hiddenInput = document.querySelector('#fields-recipient');
        form.querySelector('#fields-enquiryType').addEventListener('change', (e) => {
            hiddenInput.value = notificationAddresses[e.detail.value];
        });
    }
})();
